
// eslint-disable-next-line no-unused-vars
const {printJob, printImage} = require('../print/src/print');

const  printJobDetails = (data) => {
  printJob( {r_data: data, new_window: true});
};

export {printJobDetails};